import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserFilledIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 10 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.85859 8.33332C4.84462 8.33354 5.83065 8.3337 6.81668 8.33333C6.89609 8.3333 6.99093 8.33326 7.07448 8.34009C7.17129 8.348 7.30995 8.36829 7.45525 8.44233C7.64341 8.5382 7.79639 8.69118 7.89226 8.87934C7.96629 9.02464 7.98659 9.1633 7.9945 9.26011C8.00133 9.34366 8.00129 9.4385 8.00126 9.51791C8.00094 10.3949 8.00094 11.2718 8.00126 12.1488C8.00129 12.2282 8.00133 12.323 7.9945 12.4066C7.98659 12.5034 7.96629 12.642 7.89226 12.7873C7.79639 12.9755 7.64341 13.1285 7.45525 13.2243C7.30995 13.2984 7.17129 13.3187 7.07448 13.3266C6.99093 13.3334 6.89609 13.3334 6.81668 13.3333C4.89842 13.3326 2.97983 13.3231 1.0616 13.3334C1.01402 13.3336 0.918387 13.3342 0.827606 13.3181C0.413595 13.2451 0.0894486 12.921 0.016447 12.507C0.000439882 12.4162 0.000949224 12.3206 0.00120266 12.273C0.00329933 11.8791 -0.0168204 11.4775 0.0518959 11.0878C0.295235 9.7078 1.37572 8.62731 2.75576 8.38397C3.04403 8.33314 3.37414 8.33322 3.85859 8.33332Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.33459 3.66667C2.33459 1.64162 3.97621 0 6.00126 0C8.0263 0 9.66792 1.64162 9.66792 3.66667C9.66792 5.69171 8.0263 7.33333 6.00126 7.33333C3.97621 7.33333 2.33459 5.69171 2.33459 3.66667Z",
		fill: "currentColor"
	})]
});
export default SvgUserFilledIcon;
